<template>
  <el-table :data="childMsg.listData" style="width: 100%;padding-top: 15px;">
    <el-table-column v-for="item in childMsg.data" :prop="item.prop" :label="item.label" min-width="120"></el-table-column>
    <!-- <el-table-column label="Price" width="195" align="center">
      <template slot-scope="scope">

      </template>
    </el-table-column>
    <el-table-column label="Status" width="100" align="center">
      <template slot-scope="{row}">
        <el-tag :type="row.status | statusFilter">
          {{ row.status }}
        </el-tag>
      </template>
    </el-table-column> -->
  </el-table>
</template>

<script>
// import { transactionList } from '@/api/remote-search'

export default {
  props: ['childMsg'],
  filters: {
    // statusFilter(status) {
    //   const statusMap = {
    //     success: 'success',
    //     pending: 'danger'
    //   }
    //   return statusMap[status]
    // }
    // orderNoFilter(str) {
    //   return str.substring(0, 30)
    // }
  },
  data() {
    return {
      list: null
    }
  },
  created() {
    // this.fetchData()
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dashboard/admin/components/TransactionTable.vue